const AccordionSchema = () => ({
  title: 'AgSUS Accordion',
  fieldsets: [
    {
      id: 'default',
      title: 'Geral',
      fields: ['eyebrow', 'title', 'openFirst', 'abrirTodas'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título' },
    openFirst: {
      title: 'Abrir primeiro item por padrão',
      type: 'boolean',
      default: false,
    },
    abrirTodas: {
      title: "Mostrar 'Abrir todas'",
      description:
        'Botão acima da lista que abre ou recolhe todos os itens desta sanfona.',
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default AccordionSchema;
